import { render, staticRenderFns } from "./layoutFooter.vue?vue&type=template&id=7af20c80&"
import script from "./layoutFooter.vue?vue&type=script&lang=js&"
export * from "./layoutFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layoutFooter.vue"
export default component.exports